module.exports = __webpack_public_path__ + "img/linkedin-white.af993e8e.svg";